import React, { useEffect, useRef } from "react"
import { useOnClickOutside } from 'usehooks-ts'
import { X } from "lucide-react"
import { Toast } from "lib/components"
import { cn } from "lib/utils";

export type TModalSize = "xs"|"sm"|"md"|"lg"|"xl"|"2xl"|"3xl"|"4xl"|"max"|"wysiwyg"|"statement"


export const modalSizeValues = {
  xs: { normal: "w-[14rem] h-[9rem]", rotate: "w-[10rem] h-[14rem]" },
  sm: { normal: "w-[18rem] h-[14rem]", rotate: "w-[14rem] h-[18rem]" },
  md: { normal: "w-[24rem] h-[18rem]", rotate: "w-[18rem] h-[24rem]" },
  lg: { normal: "w-[32rem] h-[26rem]", rotate: "w-[26rem] h-[32rem]" },
  xl: { normal: "w-[40rem] h-[32rem]", rotate: "w-[32rem] h-[40rem]" },
  "2xl": { normal: "w-[48rem] h-[40rem]", rotate: "w-[40rem] h-[48rem]" },
  "3xl": { normal: "w-[56rem] h-[48rem]", rotate: "w-[48rem] h-[56rem]" },
  "4xl": { normal: "w-[62rem] h-[54rem]", rotate: "w-[54rem] h-[62rem]" },
  max: { normal: "w-[90%] h-[84%]", rotate: "w-[84%] h-[90%]" },
  wysiwyg: { normal: "w-[54rem] h-[80%]", rotate: "w-[78%] h-[30rem]"},
  statement: { normal: "w-[90%] h-[32rem]", rotate: "w-[32rem] h-[90%]"}
}

const getModalSizeClasses = (size:string|string[], rotate:boolean = false) => {
  if( Array.isArray(size) ){
    return size.join(" ")
  } else if( typeof size === "string" ){
    return rotate === true 
      ? modalSizeValues[size as keyof typeof modalSizeValues].rotate 
      : modalSizeValues[size as keyof typeof modalSizeValues].normal
  }
  return modalSizeValues.lg.normal
}

const baseModalClasses:any = "modal w-full flex flex-col grow absolute z-50 top-36 left-0 right-0 bottom-0 mx-auto bg-slate-800 rounded-md border border-solid border-linecolor overflow-hidden"
const baseModalConfig:any = { status: "closed", size: "lg", rotate: false, noMask: false, showCloseBtn: true, ignoreOutsideClick: false }

function ModalHeader({ title, showCloseBtn, onClose }:any){
  return (
    <div className="modal-header custom bg-slate-900 flex justify-between items-center h-10 px-4 py-2">
      { title !== undefined && title.length > 0 && (
        <div className="modal-title flex justify-start items-center text-xs uppercase">{title}</div>
      )}
      { showCloseBtn === true && onClose && (
        <div className={cn( "modal-closebtn-area flex justify-end items-center", (!title || !title.length) && "w-full" )}> 
          <X className="modal-closebtn w-4 h-4 rounded-bl-md rounded-tr-md cursor-pointer" onClick={onClose} /> 
        </div>
      )}
    </div>
  )
}

export default function Modal({ 
  size="xl", 
  rotate=false,
  status="closed",
  title,
  onClose, 
  noMask=false,
  showCloseBtn=true,
  ignoreOutsideClick=false,
  children,
  ...rest
}:{
  size?:TModalSize|string[]
  rotate?:boolean 
  status:"open"|"closed"
  title?:string
  onClose:any
  noMask?:boolean
  showCloseBtn?:boolean 
  ignoreOutsideClick?:boolean
  children:React.ReactNode 
  [key:string]:any
}){

  const ref = useRef(null)


  const showheader = (title !== undefined && title.length > 0) || (showCloseBtn === true)

  const handleClickOutside = () => {
    console.log('clicked outside')
    return false;
  }

  useOnClickOutside(ref, handleClickOutside)
  
  if( status !== 'open' ) return <></>
  return (
    <div className="fixed w-screen h-screen top-0 left-0 z-50">
      <div className="mask modal-mask w-screen h-screen bg-neutral-900 opacity-80 z-10">

        <Toast />

      </div>
      <div 
        className={cn(
          baseModalClasses, 
          noMask === true && 'bg-transparent',
          getModalSizeClasses(size, rotate),
          // rotate === false ? modalSizeValues[size as keyof typeof modalSizeValues].normal : modalSizeValues[size as keyof typeof modalSizeValues].rotate,
          rest.className || ""
        )}
      >
        { showheader === true && ( <ModalHeader title={title} showCloseBtn={showCloseBtn} onClose={onClose} /> )}
        <div className={cn("modal-body w-full h-full flex flex-col grow px-4 py-4 *:text-sm overflow-y-hidden", showheader === true ? 'with-header' : 'without-header')}>
          { children }
        </div>
      </div>
    </div>
  )
}